import { twMerge } from 'tailwind-merge';
import type { ColumnDefinition } from '../../table-body/table-body-components/table-row/table-row-components/table-cell/table-cell-types/column-definition';
import type { TableHeadProps } from '../TableHead';

type TableHeaderProps<Row> = Pick<ColumnDefinition<Row>, 'header' | 'accessor'> & Pick<TableHeadProps<Row>, 'headerClassName'>;

export default function TableHeader<Row>({ header, headerClassName, accessor }: TableHeaderProps<Row>) {
  const className = twMerge('text-zinc-400 tracking-wider font-normal', headerClassName);

  return (
    <th className={className}>
      {header ? header : String(accessor)}
    </th>
  );
}